import { connect } from 'react-redux';
import LogInForm from './LogInForm';
import { logIn } from './LogInActions';
import switchTab from '../app/AppActions';

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: values => dispatch(logIn(values, ownProps.onSigninSuccess)),
    signUp: () => dispatch(switchTab('signUp')),
  };
}

function mapStateToProps(state, ownProps) {
  return {
    initialValues: {
      'login-email': ownProps.customer && ownProps.customer.email,
    },
    forgotPasswordPath: ownProps.forgotPasswordPath,
    isSubmitting: state.login.isSubmitting,
    serverMessage: state.login.serverMessage,
  };
}

const LogInContainer = connect(mapStateToProps, mapDispatchToProps)(LogInForm);
export default LogInContainer;
